import { apiClient } from '../../axios';
import { GetExchangeTopTradersResponse, GetExchangeWinnersResponse } from './types';

export const getExchangeWinnersApi = () => apiClient.get<GetExchangeWinnersResponse>('/v1/exchange/winners');

export const getExchangeTopTradersApi = () => apiClient.get<GetExchangeTopTradersResponse>('/v1/exchange/top-traders');
